// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"3fc3d658","206":"4886fd2f","211":"ade8d050","255":"c665896c","302":"75773909","374":"6b1863fe","382":"3b605b84","400":"5b14c502","468":"7e9e4e6d","571":"f769463a","746":"1facbfb1","896":"ffeca0e0"}[chunkId] + ".chunk.js";
};